/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CheckinOption,
  CheckinsOptionsListParams,
  PaginatedCheckinOptionList
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * A view that can cache the queryset. Only to be used with DRF ViewSets
 *
 * * Make sure to call super().perform_destroy(instance) when overriding perform_destroy
 * * A cache hit skips the handler, so object-level permissions (those checked in
 *   `get_object`) never run on a hit. Views that use them must not cache `retrieve`.
 */
export const checkinsOptionsList = (
    params?: CheckinsOptionsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedCheckinOptionList>>,) => {
      return apiV2<PaginatedCheckinOptionList>(
      {url: `/checkins/options/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A view that can cache the queryset. Only to be used with DRF ViewSets
 *
 * * Make sure to call super().perform_destroy(instance) when overriding perform_destroy
 * * A cache hit skips the handler, so object-level permissions (those checked in
 *   `get_object`) never run on a hit. Views that use them must not cache `retrieve`.
 */
export const checkinsOptionsRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<CheckinOption>>,) => {
      return apiV2<CheckinOption>(
      {url: `/checkins/options/${id}/`, method: 'GET'
    },
      options);
    }
  export type CheckinsOptionsListResult = NonNullable<Awaited<ReturnType<typeof checkinsOptionsList>>>
export type CheckinsOptionsRetrieveResult = NonNullable<Awaited<ReturnType<typeof checkinsOptionsRetrieve>>>
